import { useEffect, useState } from "react";

export default function WalletPaymentSuccess() {
  const [response, setResponse] = useState(null);

  useEffect(() => {
    const payuData = localStorage.getItem("payu_response");
    if (payuData) {
      const parsed = JSON.parse(payuData);
      setResponse(parsed);
      console.log("PayU Payment Response:", parsed);
    }
  }, []);

  if (!response) {
    return <p>Loading payment details...</p>;
  }

  return (
    <div className="payment-success-container">
      <h1>Payment {response.status}</h1>
      <p>Transaction ID: {response.txnid}</p>
      <p>Amount: {response.amount}</p>
      <p>Name: {response.firstname}</p>
      <p>Email: {response.email}</p>
    </div>
  );
}
